// extracted by mini-css-extract-plugin
export default {"wrap":"styles_wrap__MDjip","inputs":"styles_inputs__px9Bw"};